<template>
    <b-col class="feature" :cols="cols" :lg="lg" :md="md" :xl="xl" :class="{ 'interactive': hasLink || interactive }" v-scroll-to="scrollTo">
        <b-card>
            <component :is="componentType" :to="to|tr" :href="href" :target="target" class="stretched-link">
                <e-img lazy v-if="src" :src="src" :class="{ 'wide': wideIcon, 'square': square, 'rounded': rounded }" :alt="alt"></e-img>
                <i v-if="icon" class="icon" :class="icon"></i>
                <slot></slot>
            </component>
        </b-card>
    </b-col>
</template>

<script>
    export default {
        name: `feature-card`,
        props: {
            alt: { type: String },
            src: { type: String },
            icon: { type: String },
            scrollTo: { type: String },
            to: { type: String, default: `` },
            href: { type: String, default: `` },
            target: { type: String, default: `` },
            xl: { type: String },
            lg: { type: String, default: `4` },
            md: { type: String, default: `6` },
            wideIcon: { type: Boolean },
            interactive: { type: Boolean },
            square: { type: Boolean },
            rounded: { type: Boolean },
            cols: { type: String, default: `12` }
        },
        computed: {
            componentType() {
                if (!isStringEmpty(this.href)) {
                    return `a`;
                } else if (!isStringEmpty(this.to)) {
                    return `router-link`;
                } else {
                    return `div`
                }
            },
            hasLink() {
                return !isStringEmpty(this.to) || !isStringEmpty(this.href) || !isStringEmpty(this.scrollTo);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .feature {
        text-align: center;

        &.interactive {
            cursor: pointer;

            .card {
                &:hover {
                    box-shadow: 0 5px 30px rgba(0, 0, 0, 0.1);
                    position: relative;
                    z-index: 1;
                }

                a {
                    color: inherit;
                    text-decoration: none !important;
                }
            }
        }

        .icon {
            margin: 10px auto;
            font-size: 40px;
        }

        img {
            width: 128px;
            margin: 10px auto;

            &.wide {
                width: 180px;
            }

            &.square {
                width: 280px;
                height: 280px;
                object-fit: cover;
            }
        }

        p {
            opacity: 0.85;
            margin: 0;
        }

        @media(max-width: 576px) {
            margin: 0;

            .card {
                margin: 0;

                .card-body {
                    padding: 0.5em;

                    p {
                        font-size: 11pt;
                    }
                }
            }
        }
    }

    .page.inverted {
        .feature {
            &.interactive {
                .card {

                    &:hover {
                        background: #0a0a0a;
                        //box-shadow: 0 0 0 1px #9edbd4, 0 0 5px turquoise, inset 0 0 5px turquoise;
                    }
                }
            }
        }
    }
</style>
